import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { firstValueFrom } from 'rxjs';

export const AdminGuard: CanActivateFn = async (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const isAuthenticated = await firstValueFrom(auth.isAuthenticated$);
  if (!isAuthenticated) {
    auth.loginWithRedirect({ appState: { target: state.url } });
    return false;
  }

  const user = await firstValueFrom(auth.user$);
  const roles = user?.['/roles'] ?? [];

  if (!roles.includes('ctadmin')) {
    router.navigateByUrl('/dashboard');
    return false;
  }

  return true;
};
